import React from "react"

import { EmailVerificationPageView } from "./EmailVerificationPageView"
import { usePostEmailVerificationPageViewModel } from "./hooks/usePostEmailVerificationPageViewModel"

export interface PostEmailVerificationPageModel {
  navigateToHomepage: () => void
  verificationFailed: boolean
}

export const PostEmailVerificationPage = React.memo(
  (props: PostEmailVerificationPageModel) => {
    return (
      <EmailVerificationPageView
        {...usePostEmailVerificationPageViewModel(props)}
      />
    )
  }
)
